export default {
	"Grocery Stores": "#FF0000",
	"Movie Theaters": "#a30b13",
	Restaurants: "#61a30b",
	Pools: "#3da6e3",
	Schools: "#a88f3b",
	Hospitals: "#b51825",
	Retail: "#b54c18",
	"Water Features": "#2ca3f2",
	Transportation: "#6516ab",
	Recreation: "#55a0e6",
	Entertainment: "#fc8c03",
	Parks: "#306900",
	Playground: "#31913e",
	"Dog Park": "#916f31",
	Golf: "#58b536",
	"Fire Station": "#9c0b12",
	Library: "#c4842f",
}
